import * as React from 'react';
import Box from "@mui/material/Box";
import makeStyles from "@mui/styles/makeStyles";
import {TabPanel} from "../../../components/other/tabPanel";
import {StyledTabs, StyledTab} from "../admin";
import {Button, FormControlLabel, Switch} from "@mui/material";
import DocReports from './doc_reports';
import DocReportsSum from './doc_reports_summary';
import AuditsTable from './audits_table';
import AuditReports from './audit_reports';
import {AgyleNamedIcon} from '../../../components/icons/agyle';
import UserLoginAudit from './user_login_audit';
import {useDispatch} from "react-redux";
import {hasOneOfPermission, Permissions} from '../../../store/reducers/user';

const useStyles = makeStyles((theme) => ({
    indicator: {
        backgroundColor: "#448FFF"
    },
    switch_base: {
        "&.Mui-checked": {
            color: "#448FFF"
        },
        "&.Mui-checked + .MuiSwitch-track": {
            backgroundColor: "#448FFF",
        }
    },
}));

function ReportsDashboard(props) {
    const [value, setValue] = React.useState(0);
    const classes = useStyles();
    const docReportRef = React.useRef(null);
    const docReportSumRef = React.useRef(null);
    const auditSumRef = React.useRef(null);
    const userLoginRef = React.useRef(null);
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const dispatch = useDispatch()

    const [filterHidden, setFiltersHidden] = React.useState(false);
    const [timeInUtc, setTimeInUtc] = React.useState(false);

    const handleHideFilters = (e) => {
        setFiltersHidden(e.target.checked);
        e.stopPropagation();
    }
    const handleTimeToggle = (e) => {
        setTimeInUtc(e.target.checked);
        e.stopPropagation();
    }

    const [liveMessage, setLiveMessage] = React.useState(false);

    const handleLive = (e) => {
        setLiveMessage(e.target.checked);
        e.stopPropagation();
    }
    const exportCsv = (event) => {
        if(value==0) {
            docReportRef.current.exportCsv();
        }
        if(value==1) {
            docReportSumRef.current.exportCsv();
        }
        if(value==2) {
            auditSumRef.current.exportCsv();
        }
        if(value==3) {
            userLoginRef.current.exportCsv();
        }
    }
    const switchVisible = () => {
        return value === 0 || value === 1 || value === 2;
    }
    return (<Box sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider',display: 'flex', justifyContent: 'space-between', paddingRight: "25px" }}>
            <StyledTabs value={value} onChange={handleChange} aria-label="Report labels" TabIndicatorProps={{className: classes.indicator}}>
                {dispatch(hasOneOfPermission([Permissions.CAN_ACCESS_ADMIN_PAGE, Permissions.CAN_ACCESS_REPORTS, Permissions.CAN_ACCESS_STATISTICS])) && <StyledTab value={0} label="Image Statistic"/>}
                {dispatch(hasOneOfPermission([Permissions.CAN_ACCESS_ADMIN_PAGE, Permissions.CAN_ACCESS_REPORTS, Permissions.CAN_ACCESS_STATISTICS])) && <StyledTab value={1} label="Image Statistic Summary" />}
                {dispatch(hasOneOfPermission([Permissions.CAN_ACCESS_ADMIN_PAGE, Permissions.CAN_ACCESS_REPORTS])) && <StyledTab value={2} label="User/Patient Audit" />}
                {dispatch(hasOneOfPermission([Permissions.CAN_ACCESS_ADMIN_PAGE, Permissions.CAN_ACCESS_REPORTS])) && <StyledTab value={3} label="User Login Audit" />}
            </StyledTabs>
            {switchVisible() &&
            <div style={{display: "inline-flex", alignItems: "center"}}>
                <div style={{display: "flex"}}>
                    <FormControlLabel label={"Hide Filters "} control={
                        <Switch classes={{switchBase: classes.switch_base}} checked={filterHidden} size="small" onChange={handleHideFilters}/>}
                    />
                </div>
                <div style={{display: "flex"}}>
                    <FormControlLabel label={"UTC"} control={
                        <Switch classes={{switchBase: classes.switch_base}} checked={timeInUtc} size="small" onChange={handleTimeToggle}/>}
                    />
                </div>
                <Button variant="outlined" className={classes.btnIcon} onClick={exportCsv}><AgyleNamedIcon name="download" className={classes.icon}/></Button>
            </div>
            }

        </Box>
        {dispatch(hasOneOfPermission([Permissions.CAN_ACCESS_ADMIN_PAGE, Permissions.CAN_ACCESS_REPORTS, Permissions.CAN_ACCESS_STATISTICS])) && <TabPanel value={value} index={0}>
            <DocReports filterHidden = {filterHidden} liveMessage={liveMessage}  timeInUtc = {timeInUtc} ref={docReportRef}/>
        </TabPanel>}
        {dispatch(hasOneOfPermission([Permissions.CAN_ACCESS_ADMIN_PAGE, Permissions.CAN_ACCESS_REPORTS, Permissions.CAN_ACCESS_STATISTICS])) && <TabPanel value={value} index={1}>
            <DocReportsSum filterHidden = {filterHidden} liveMessage={liveMessage} timeInUtc = {timeInUtc} ref={docReportSumRef}/>
        </TabPanel>}
        {dispatch(hasOneOfPermission([Permissions.CAN_ACCESS_ADMIN_PAGE, Permissions.CAN_ACCESS_REPORTS])) && <TabPanel value={value} index={2}>
            <AuditReports filterHidden = {filterHidden} liveMessage={liveMessage} timeInUtc = {timeInUtc} ref={auditSumRef}/>
        </TabPanel>}
        {dispatch(hasOneOfPermission([Permissions.CAN_ACCESS_ADMIN_PAGE, Permissions.CAN_ACCESS_REPORTS])) && <TabPanel value={value} index={3}>
            <UserLoginAudit filterHidden = {filterHidden} timeInUtc = {timeInUtc} ref={userLoginRef}/>
        </TabPanel>}
    </Box>)
}

export default ReportsDashboard;